import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Output,
  QueryList,
  TemplateRef,
  input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabComponent } from './tab/tab.component';
import { IconsComponent } from '../icons/icons.component';
import { SwipeDirective } from 'src/app/directives/swipe.directive';
import { TabIndex } from './tab-index.model';

export type TabStyle = 'vertical' | 'horizontal';

@Component({
  selector: 'vti-tabs',
  standalone: true,
  imports: [CommonModule, IconsComponent, SwipeDirective],
  templateUrl: './tabs.component.html',
  styles: [
    `
      .h-50 {
        height: 50vh;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsComponent implements AfterViewInit {
  @ContentChildren(TabComponent) public tabs!: QueryList<TabComponent>;

  public tabIndex = input<TabIndex>('summary');
  public style = input<TabStyle>('vertical');

  @Output() public onTabClick = new EventEmitter<TabIndex>();

  public ngAfterViewInit(): void {
    this.currentTabIndex.update(() => this.tabIndex());
    if (this.tabs.length) {
      setTimeout(() => {
        this.currentTab.set((this.tabs.get(0) as TabComponent).template);
      });
    }
  }

  public setCurrentTab(index: TabIndex, emit = true): void {
    this.currentTabIndex.update(() => index);
    this.currentTab.update(() => (this.tabs.find((f) => f.index() === index) as TabComponent).template);
    this.hideMobileTabs.update(() => true);

    if (emit) {
      setTimeout(() => {
        this.onTabClick.emit(index);
      });
    }
  }

  public triggerMobileTabs(show: boolean): void {
    this.hideMobileTabs.update(() => !show);
  }

  public currentTab = signal<TemplateRef<any> | null>(null);
  public currentTabIndex = signal<TabIndex>('summary');
  public hideMobileTabs = signal<boolean>(true);
}
